export const paymentMethod = {
  CASH: "Efectivo",
  TRANSFER: "Transferencia",
  CREDIT_CARD: "Tarjeta de crédito",
  CREDIT: "Crédito",
  PAYMENT_LINK: "Link de pago",
};
